import { CircleCheck } from "lucide-react";
import React from "react";
import { toast } from "sonner";

export const useFeedback = () => {
  const copyFeedback = async (content: string) => {
    if (!content) return;

    try {
      await navigator.clipboard.writeText(content);
      toast("Feedback copied to clipboard", {
        description: "The feedback content has been copied to your clipboard.",
        icon: React.createElement(CircleCheck, { className: "h-4 w-4" }),
        position: "bottom-right",
      });
    } catch {
      toast.error("Failed to copy feedback", {
        description: "Please try again later.",
        position: "bottom-right",
      });
    }
  };

  return {
    copyFeedback,
  };
};
